<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">From Robber Barons to Courtiers<a id="page_ii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?2efcf646